<ion-accordion-group #accordionGroup>
    <ng-container [ngSwitch]="env.APP_NAME">
        <ng-container *ngSwitchCase="'sormland'">
            <li
                class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                *ngIf="helperService.isAllowedPath('/profile') && ridangoAuth.getLoginStatus()"
                [routerLink]="'/account/profile' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeMobileMenu()"
                (keydown.enter)="activateMenuItem($event)"
                routerLinkActive="font-bold"
                ariaCurrentWhenActive="page"
                role="button"
                tabindex="0">
                <ion-icon
                    class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] text-primary-text dark:text-contrast-yellow"
                    name="person"></ion-icon>
                <span
                    class="orb-app-light:text-white var-app-light:text-white text-primary-text dark:text-contrast-yellow">
                    {{ 'MORE_MENU_MANAGE_ACCOUNT' | translate }}
                </span>
            </li>
            <div
                class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
                *ngIf="helperService.isAllowedPath('/profile') && ridangoAuth.getLoginStatus()"></div>

            <li
                class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                *ngIf="helperService.isAllowedPath('/disruption-messages')"
                [routerLink]="'/disruption-messages' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeMobileMenu()"
                (keydown.enter)="activateMenuItem($event)"
                routerLinkActive="font-bold"
                ariaCurrentWhenActive="page"
                role="button"
                tabindex="0">
                <ion-icon
                    class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] text-primary-text dark:text-contrast-yellow"
                    name="warning"></ion-icon>
                <span class="orb-app-light:text-white var-app-light:text-white">
                    {{ 'HEADER_DISRUPTION_MESSAGES' | translate }}
                </span>
            </li>

            <li
                class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                *ngIf="env.HEADER?.REDIRECT_TO_MY_ACCOUNT_WEB && ridangoAuth.getLoginStatus()"
                (click)="redirectToMinaSidor()"
                (keydown.enter)="redirectToMinaSidor()"
                role="button"
                tabindex="0">
                <ion-icon
                    class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] text-primary-text dark:text-contrast-yellow"
                    name="warning"></ion-icon>
                <span class="orb-app-light:text-white var-app-light:text-white">
                    {{ 'MINA_SIDOR' | translate }}
                </span>
            </li>

            <div
                class="menu-divider border-primary-lighter orb-app-light-dark:hidden ml-16 mr-8 border-solid dark:border-grey-white_smoke"
                *ngIf="helperService.isAllowedPath('/disruption-messages') && ridangoAuth.getLoginStatus()"></div>
            <li
                class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                *ngIf="ridangoAuth.getLoginStatus() && !env.HEADER?.HIDE_FEEDBACK"
                [routerLink]="'/feedback' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeMobileMenu()"
                (keydown.enter)="activateMenuItem($event)"
                routerLinkActive="font-bold"
                ariaCurrentWhenActive="page"
                role="button"
                tabindex="0">
                <div class="mr-6 h-6 w-6">
                    <mat-icon
                        class="var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow"
                        icon
                        svgIcon="feedback"
                        alt="feedback"></mat-icon>
                </div>
                <span class="var-app-light:text-white text-primary-text dark:text-contrast-yellow">
                    {{ 'MORE_MENU_FEEDBACK' | translate }}
                </span>
            </li>
            <div
                class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
                *ngIf="ridangoAuth.getLoginStatus() && !env.HEADER?.HIDE_FEEDBACK"></div>
            <li
                class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                *ngIf="helperService.isAllowedPath('/account/purchase-history') && ridangoAuth.getLoginStatus()"
                [routerLink]="'/account/purchase-history' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeMobileMenu()"
                (keydown.enter)="activateMenuItem($event)"
                routerLinkActive="font-bold"
                ariaCurrentWhenActive="page"
                role="button"
                tabindex="0">
                <div class="mr-6 h-6 w-6">
                    <mat-icon
                        class="var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow"
                        icon
                        svgIcon="purchase"
                        alt="purchase"></mat-icon>
                </div>
                <span class="var-app-light:text-white text-primary-text dark:text-contrast-yellow">
                    {{ 'MY_ACCOUNT_PURCHASE_HISTORY' | translate }}
                </span>
            </li>

            <ion-accordion
                class="dark:dark-accordion bg-primary-lighter orb-app-light:bg-secondary-tint var-app-light:bg-primary-tint var-app-light:text-white orb-app-light:text-white mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
                toggleIcon="chevron-forward-outline"
                toggleIconSlot="start"
                value="settings">
                <ion-item class="text-base" slot="header" color="primary-lighter">
                    <ion-label
                        class="orb-app-light:text-white var-app-light:text-white text-base font-bold dark:text-contrast-yellow"
                        [class.uppercase]="!env.REMOVE_UPPERCASE"
                        >{{ 'MORE_MENU_SETTINGS' | translate }}</ion-label
                    >
                </ion-item>
                <div
                    class="ion-padding orb-app-light:bg-secondary bg-[var(--color-primary)] dark:bg-contrast-black"
                    slot="content">
                    <li
                        class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                        *ngIf="ridangoAuth.getLoginStatus() && !env.HEADER?.HIDE_PAYMENT_SETTINGS"
                        [routerLink]="'/purchase/wallet' | localize"
                        [routerLinkActiveOptions]="{ exact: false }"
                        (click)="closeMobileMenu()"
                        (keydown.enter)="activateMenuItem($event)"
                        routerLinkActive="font-bold"
                        ariaCurrentWhenActive="page"
                        role="button"
                        tabindex="0">
                        <div class="mr-6 h-6 w-6">
                            <mat-icon
                                class="orb-app-light:text-white var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow"
                                icon
                                svgIcon="coins"
                                alt="coins"></mat-icon>
                        </div>
                        <span
                            class="orb-app-light:text-white var-app-light:text-white text-primary-text dark:text-contrast-yellow">
                            {{ 'MORE_MENU_PAYMENT_SETTING' | translate }}
                        </span>
                    </li>
                    <div
                        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
                        *ngIf="ridangoAuth.getLoginStatus() && !env.HEADER?.HIDE_PAYMENT_SETTINGS"></div>
                    <li
                        class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                        [routerLink]="'/account/notification-settings' | localize"
                        [routerLinkActiveOptions]="{ exact: false }"
                        (click)="closeMobileMenu()"
                        (keydown.enter)="activateMenuItem($event)"
                        routerLinkActive="font-bold"
                        ariaCurrentWhenActive="page"
                        role="button"
                        tabindex="0">
                        <ion-icon
                            class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] text-primary-text dark:text-contrast-yellow"
                            name="notifications"></ion-icon>
                        <span
                            class="orb-app-light:text-white var-app-light:text-white flex items-center text-primary-text dark:text-contrast-yellow">
                            {{ 'MY_ACCOUNT_NOTIFICATION_SETTINGS' | translate }}
                        </span>
                    </li>
                    <div
                        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"></div>
                    <li
                        class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                        (click)="toggleContrast()"
                        (keydown.enter)="toggleContrast()"
                        role="button"
                        tabindex="0">
                        <div
                            class="orb-app-light:bg-white var-app-light:bg-white vl-app-light:bg-grey-white_smoke mr-6 flex h-6 w-6 items-center justify-center rounded-full bg-primary-text dark:bg-contrast-yellow">
                            <ion-icon
                                class="orb-app-light:text-[var(--color-secondary)] var-app-light:text-white text-[1rem] text-primary dark:text-contrast-black"
                                name="accessibility"></ion-icon>
                        </div>
                        <span
                            class="orb-app-light:text-white var-app-light:text-white font-light text-primary-text dark:text-contrast-yellow">
                            {{ 'ONBOARDING_ACCESSIBILITY' | translate }}
                        </span>
                    </li>
                    <div
                        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"></div>
                    <li
                        class="menu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
                        *ngIf="!env.HEADER?.HIDE_LANGUAGE_SELECTOR && env.IS_MOBILE_APP"
                        (click)="openSelectLanguageMenu()"
                        (keydown.enter)="openSelectLanguageMenu()"
                        role="button"
                        tabindex="0">
                        <mat-icon
                            class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] text-primary-text dark:text-contrast-yellow"
                            >language
                        </mat-icon>
                        <span
                            class="orb-app-light:text-white var-app-light:text-white font-light text-primary-text dark:text-contrast-yellow">
                            {{ 'LANGUAGE' | translate }}
                        </span>
                    </li>
                </div>
            </ion-accordion>
            <ion-accordion
                class="orb-app-light:text-white var-app-light:text-white dark:dark-accordion bg-primary-lighter orb-app-light:bg-secondary-tint var-app-light:bg-primary-tint mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
                toggleIcon="chevron-forward-outline"
                toggleIconSlot="start"
                value="about-app">
                <ion-item class="" slot="header" color="primary-lighter">
                    <ion-label
                        class="orb-app-light:text-white var-app-light:text-white text-base font-bold dark:text-contrast-yellow"
                        [class.uppercase]="!env.REMOVE_UPPERCASE"
                        >{{ 'MORE_MENU_ABOUT_APP' | translate }}</ion-label
                    >
                </ion-item>
                <div
                    class="ion-padding orb-app-light:bg-secondary bg-[var(--color-primary)] dark:bg-contrast-black"
                    slot="content">
                    <li
                        class="menu-focusable flex h-14 cursor-pointer items-center"
                        *ngIf="helperService.isAllowedPath('/about')"
                        [routerLink]="'/about' | localize"
                        [routerLinkActiveOptions]="{ exact: false }"
                        (click)="closeMobileMenu()"
                        (keydown.enter)="activateMenuItem($event)"
                        routerLinkActive="font-bold"
                        ariaCurrentWhenActive="page"
                        role="button"
                        tabindex="0">
                        <span
                            class="orb-app-light:text-white var-app-light:text-white flex items-center pl-[3.7rem] font-light text-primary-text dark:text-contrast-yellow">
                            {{ 'MORE_MENU_ABOUT' | translate }}
                        </span>
                    </li>
                </div>
            </ion-accordion>
            <ion-accordion
                class="orb-app-light:text-white var-app-light:text-white dark:dark-accordion bg-primary-lighter orb-app-light:bg-secondary-tint var-app-light:bg-primary-tint mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
                toggleIcon="chevron-forward-outline"
                toggleIconSlot="start"
                value="info">
                <ion-item class="" slot="header" color="primary-lighter">
                    <ion-label
                        class="orb-app-light:text-white var-app-light:text-white text-base font-bold dark:text-contrast-yellow"
                        [class.uppercase]="!env.REMOVE_UPPERCASE"
                        >{{ 'MORE_MENU_INFO' | translate }}</ion-label
                    >
                </ion-item>
                <div
                    class="ion-padding orb-app-light:bg-secondary bg-[var(--color-primary)] dark:bg-contrast-black"
                    slot="content">
                    <li
                        class="menu-focusable flex h-14 cursor-pointer items-center"
                        [routerLink]="'/terms-and-conditions' | localize"
                        [routerLinkActiveOptions]="{ exact: false }"
                        (click)="closeMobileMenu()"
                        (keydown.enter)="activateMenuItem($event)"
                        routerLinkActive="font-bold"
                        ariaCurrentWhenActive="page"
                        role="button"
                        tabindex="0">
                        <span
                            class="orb-app-light:text-white var-app-light:text-white flex items-center pl-[3.7rem] font-light text-primary-text dark:text-contrast-yellow">
                            {{ 'MOBILE_MENU_TERSM_AND_CONDITIONS' | translate }}
                        </span>
                    </li>
                    <li class="flex h-14 cursor-pointer items-center" *ngIf="env.HEADER?.SHOW_FAQ">
                        <a
                            class="orb-app-light:text-white var-app-light:text-white flex h-14 w-full items-center pl-[3.7rem] font-light text-primary-text dark:text-contrast-yellow"
                            (click)="closeMobileMenu(true)"
                            href="{{ 'HEADER_FAQ_LINK' | translate }}"
                            target="_blank">
                            {{ 'HEADER_FAQ' | translate }}
                        </a>
                    </li>

                    <div
                        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
                        *ngIf="env.HEADER?.DELAY_COMPENSATION_LINK"></div>
                    <li class="flex h-14 cursor-pointer items-center" *ngIf="env.HEADER?.DELAY_COMPENSATION_LINK">
                        <a
                            class="flex h-14 w-full items-center pl-[3.7rem] font-light text-primary-text dark:text-contrast-yellow"
                            [href]="env.HEADER?.DELAY_COMPENSATION_LINK[(this.selectedLanguage$ | async).code]"
                            (click)="closeMobileMenu(true)"
                            target="_blank">
                            {{ 'DELAY_COMPENSATION' | translate }}
                        </a>
                    </li>
                </div>
            </ion-accordion>
            <ion-accordion
                class="orb-app-light:text-white var-app-light:text-white dark:dark-accordion bg-primary-lighter orb-app-light:bg-secondary-tint var-app-light:bg-primary-tint mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
                toggleIcon="chevron-forward-outline"
                toggleIconSlot="start"
                value="contact-us">
                <ion-item class="" slot="header" color="primary-lighter">
                    <ion-label
                        class="orb-app-light:text-white var-app-light:text-white text-base font-bold dark:text-contrast-yellow"
                        [class.uppercase]="!env.REMOVE_UPPERCASE"
                        >{{ 'MORE_MENU_CONTACT_US' | translate }}</ion-label
                    >
                </ion-item>
                <div
                    class="ion-padding orb-app-light:bg-secondary bg-[var(--color-primary)] dark:bg-contrast-black"
                    slot="content">
                    <li
                        class="flex h-14 cursor-pointer items-center"
                        *ngIf="env.APP_NAME === 'sormland'; else defaultContact">
                        <a
                            class="flex h-14 w-full items-center pl-6 text-base font-light text-primary-text dark:text-contrast-yellow"
                            (click)="closeMobileMenu(true)"
                            href="https://sormlandstrafiken.se/kundservice/lamna-en-kundsynpunkt"
                            target="_blank">
                            <mat-icon
                                class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] dark:text-contrast-yellow"
                                >mail</mat-icon
                            >
                            <span>{{ 'HEADER_MAIL_US' | translate }}</span>
                        </a>
                    </li>
                    <ng-template #defaultContact>
                        <li class="flex h-14 cursor-pointer items-center">
                            <a
                                class="orb-app-light:text-white var-app-light:text-white flex h-14 w-full items-center pl-6 text-base font-light text-primary-text dark:text-contrast-yellow"
                                (click)="closeMobileMenu(true)"
                                href="mailto:{{ 'MAIL_AT_LINK' | translate }}"
                                target="_blank">
                                <mat-icon
                                    class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] dark:text-contrast-yellow"
                                    >mail</mat-icon
                                >
                                <span>{{ 'HEADER_MAIL_US' | translate }}</span>
                            </a>
                        </li>
                    </ng-template>

                    <li class="flex h-14 cursor-pointer items-center">
                        <a
                            class="orb-app-light:text-white var-app-light:text-white flex h-14 w-full items-center pl-6 text-base text-primary-text dark:text-contrast-yellow"
                            [href]="'tel:' + ('FOOTER_PHONE_TEXT' | translate)">
                            <mat-icon
                                class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] dark:text-contrast-yellow"
                                >call</mat-icon
                            >
                            <span>{{ 'FOOTER_PHONE_TEXT' | translate }}</span>
                        </a>
                    </li>
                    <li class="flex h-14 cursor-pointer items-center" *ngIf="env.HEADER?.SHOW_EXTERNAL_SUPPORT_URL">
                        <a
                            class="orb-app-light:text-white var-app-light:text-white flex h-14 w-full items-center pl-6 text-base text-primary-text dark:text-contrast-yellow"
                            [href]="'FOOTER_EXTERNAL_SUPPORT_URL' | translate">
                            <mat-icon
                                class="orb-app-light:text-white var-app-light:text-white mr-6 text-[1.5rem] dark:text-contrast-yellow"
                                >info</mat-icon
                            >
                            <span>{{ 'FOOTER_EXTERNAL_SUPPORT' | translate }}</span>
                        </a>
                    </li>
                </div>
            </ion-accordion>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <ng-container *ngFor="let headerElement of menuItems">
                <ng-container *ngIf="headerElement.label.length === 0 && headerElement.id?.length === 0">
                    <ng-container *ngTemplateOutlet="headerElementWithoutAccordion; context: { headerElement }">
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="headerElement.label.length !== 0 && headerElement.id?.length !== 0">
                    <ng-container *ngTemplateOutlet="headerElementWithAccordion; context: { headerElement }">
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ion-accordion-group>

<!-- Menu sections: with/without accordions -->

<ng-template #headerElementWithAccordion let-headerElement="headerElement">
    <ion-accordion
        class="dark:dark-accordion bg-primary-lighter orb-app-light:bg-blue-light var-app-light:bg-primary-tint var-app-light:text-white orb-app-light:text-white mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
        toggleIcon="chevron-forward-outline"
        toggleIconSlot="start"
        value="{{ headerElement.id }}">
        <ion-item class="text-base" slot="header" color="primary-lighter">
            <ion-label
                class="orb-app-light:text-white var-app-light:text-white text-base font-bold dark:text-contrast-yellow"
                [class.uppercase]="!env.REMOVE_UPPERCASE"
                >{{ headerElement.label | translate }}</ion-label
            >
        </ion-item>
        <div
            class="ion-padding orb-app-light:bg-secondary bg-[var(--color-primary)] dark:bg-contrast-black"
            slot="content">
            <ng-container *ngFor="let headerElementChildren of headerElement.subPaths; let index = index">
                <ng-container [ngSwitch]="headerElementChildren.type">
                    <ng-container *ngSwitchCase="HeaderSubItemType.TEXT">
                        <ng-container
                            *ngTemplateOutlet="textItem; context: { headerElementChildren, isFirst: index === 0 }">
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="HeaderSubItemType.EMAIL">
                        <ng-container
                            *ngTemplateOutlet="emailItem; context: { headerElementChildren, isFirst: index === 0 }">
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="HeaderSubItemType.PHONE">
                        <ng-container
                            *ngTemplateOutlet="phoneItem; context: { headerElementChildren, isFirst: index === 0 }">
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="HeaderSubItemType.EXTERNAL_LINK">
                        <ng-container
                            *ngTemplateOutlet="
                                externalLinkItem;
                                context: { headerElementChildren, isFirst: index === 0 }
                            ">
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="HeaderSubItemType.ACCESSIBILITY">
                        <ng-container
                            *ngTemplateOutlet="
                                accessibilityItem;
                                context: { headerElementChildren, isFirst: index === 0 }
                            ">
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="HeaderSubItemType.LANGUAGE">
                        <ng-container
                            *ngTemplateOutlet="languageItem; context: { headerElementChildren, isFirst: index === 0 }">
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ion-accordion>
</ng-template>

<ng-template #headerElementWithoutAccordion let-headerElement="headerElement">
    <ng-container *ngFor="let headerElementChildren of headerElement.subPaths; let index = index">
        <ng-container *ngTemplateOutlet="textItem; context: { headerElementChildren, isFirst: index === 0 }">
        </ng-container>
    </ng-container>
</ng-template>

<!-- Menu items possible templates -->

<ng-template #textItem let-item="headerElementChildren" let-isFirst="isFirst">
    <ng-container *ngIf="isMenuItemAllowed(item)">
        <div
            class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
            *ngIf="!isFirst"></div>
        <li
            class="menu-focusable menu-submenu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
            [ngClass]="{ 'font-bold': isActive(item.path) }"
            [attr.aria-current]="isActive(item.path)"
            [routerLink]="item.path | localize"
            (click)="closeMobileMenu()"
            (keydown.enter)="activateMenuItem($event)"
            routerLinkActive
            role="button"
            tabindex="0">
            <div class="orb-app-light-dark:relative mr-4 h-8 w-8">
                <mat-icon
                    class="template-icon orb-app-light:[--svg-color:theme(colors.secondary.DEFAULT)] orb-app-light:text-white var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow dark:[--svg-color:black]"
                    [svgIcon]="item.icon"
                    icon
                    alt="{{ item.icon }}">
                </mat-icon>
                <ng-container *ngIf="receivedMessagesCount$ | async as receivedCount">
                    <div
                        class="received-count absolute"
                        *ngIf="
                            env.HEADER?.SHOW_MESSAGES && item.path === '/account/messages' && receivedCount?.unread > 0
                        ">
                        {{ receivedCount?.unread }}
                    </div>
                </ng-container>
            </div>
            <span class="orb-app-light:text-white var-app-light:text-white text-primary-text dark:text-contrast-yellow">
                {{ item.label | translate }}
            </span>
        </li>
    </ng-container>
</ng-template>

<ng-template #emailItem let-item="headerElementChildren" let-isFirst="isFirst">
    <ng-container *ngIf="isMenuItemAllowed(item)">
        <div
            class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
            *ngIf="!isFirst"></div>
        <li class="flex h-14 cursor-pointer items-center text-base">
            <a
                class="menu-focusable menu-submenu-focusable orb-app-light:text-white var-app-light:text-white flex h-14 w-full items-center pl-6 text-primary-text dark:text-contrast-yellow"
                [ngClass]="{ 'font-bold': isActive(item.path) }"
                [attr.aria-current]="isActive(item.path)"
                [href]="'mailto:' + (item.path | translate)"
                (click)="closeMobileMenu(true)">
                <div class="mr-4 h-8 w-8">
                    <mat-icon
                        class="template-icon orb-app-light:[--svg-color:theme(colors.secondary.DEFAULT)] orb-app-light:text-white var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow dark:[--svg-color:black]"
                        [svgIcon]="item.icon"
                        icon
                        alt="{{ item.icon }}">
                    </mat-icon>
                </div>
                {{ item.label | translate }}
            </a>
        </li>
    </ng-container>
</ng-template>

<ng-template #phoneItem let-item="headerElementChildren" let-isFirst="isFirst">
    <ng-container *ngIf="isMenuItemAllowed(item)">
        <div
            class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
            *ngIf="!isFirst"></div>
        <li class="flex h-14 cursor-pointer items-center text-base">
            <a
                class="menu-focusable menu-submenu-focusable orb-app-light:text-white var-app-light:text-white flex h-14 w-full items-center pl-6 text-primary-text dark:text-contrast-yellow"
                [ngClass]="{ 'font-bold': isActive(item.path) }"
                [attr.aria-current]="isActive(item.path)"
                [href]="'tel:' + (item.path | translate)"
                (click)="closeMobileMenu(true)">
                <div class="mr-4 h-8 w-8">
                    <mat-icon
                        class="template-icon orb-app-light:[--svg-color:theme(colors.secondary.DEFAULT)] orb-app-light:text-white var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow dark:[--svg-color:black]"
                        [svgIcon]="item.icon"
                        icon
                        alt="{{ item.icon }}">
                    </mat-icon>
                </div>
                {{ item.label | translate }}
            </a>
        </li>
    </ng-container>
</ng-template>

<ng-template #externalLinkItem let-item="headerElementChildren" let-isFirst="isFirst">
    <ng-container *ngIf="isMenuItemAllowed(item)">
        <div
            class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
            *ngIf="!isFirst"></div>
        <li class="flex h-14 cursor-pointer items-center text-base">
            <a
                class="menu-focusable menu-submenu-focusable orb-app-light:text-white var-app-light:text-white dark:text-dark-contrast-yellow flex h-14 w-full items-center justify-between pl-6 text-primary-text"
                [ngClass]="{ 'font-bold': isActive(item.path) }"
                [attr.aria-current]="isActive(item.path)"
                [href]="item.path | translate"
                (click)="closeMobileMenu(true)"
                target="_blank">
                <div class="flex items-center">
                    <div class="external-link__icon mr-4 h-8 w-8">
                        <mat-icon
                            class="template-icon orb-app-light:[--svg-color:theme(colors.secondary.DEFAULT)] orb-app-light:text-white var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow dark:[--svg-color:black]"
                            [svgIcon]="item.icon"
                            icon
                            alt="{{ item.icon }}">
                        </mat-icon>
                    </div>
                    <span>{{ item.label | translate }}</span>
                </div>
                <div class="mr-6 h-8 w-8" *ngIf="item.flags && item.flags.includes('isHasExternalIcon')">
                    <mat-icon
                        class="orb-app-light:text-white var-app-light:text-white h-8 w-8 text-[1.5rem] dark:text-contrast-yellow"
                        svgIcon="external-link"
                        icon
                        alt="external-link">
                    </mat-icon>
                </div>
            </a>
        </li>
    </ng-container>
</ng-template>

<ng-template #accessibilityItem let-item="headerElementChildren" let-isFirst="isFirst">
    <div
        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
        *ngIf="!isFirst"></div>
    <li
        class="menu-focusable menu-submenu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
        [ngClass]="{ 'font-bold': isActive(item.path) }"
        [attr.aria-label]="
            (isContrast$ | async)
                ? ('TURN_OFF_HIGH_CONTRAST_MODE' | translate)
                : ('TURN_ON_HIGH_CONTRAST_MODE' | translate)
        "
        (click)="toggleContrast()"
        (keydown.enter)="toggleContrast()"
        role="button"
        tabindex="0">
        <div class="mr-4 h-8 w-8">
            <mat-icon
                class="template-icon orb-app-light:[--svg-color:theme(colors.secondary.DEFAULT)] orb-app-light:text-white var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow dark:[--svg-color:black]"
                [svgIcon]="item.icon"
                icon
                alt="{{ item.icon }}">
            </mat-icon>
        </div>
        <span class="orb-app-light:text-white var-app-light:text-white text-primary-text dark:text-contrast-yellow">
            {{ item.label | translate }}
        </span>
    </li>
</ng-template>

<ng-template #languageItem let-item="headerElementChildren" let-isFirst="isFirst">
    <div
        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
        *ngIf="!isFirst"></div>
    <li
        class="menu-focusable menu-submenu-focusable flex h-14 cursor-pointer items-center pl-6 text-base"
        (click)="openSelectLanguageMenu()"
        (keydown.enter)="openSelectLanguageMenu()"
        role="button"
        tabindex="0">
        <div class="mr-4 h-8 w-8">
            <mat-icon
                class="template-icon orb-app-light:text-white var-app-light:text-white text-[1.5rem] dark:text-contrast-yellow"
                [svgIcon]="item.icon"
                icon
                alt="{{ item.icon }}">
            </mat-icon>
        </div>
        <span class="orb-app-light:text-white var-app-light:text-white text-primary-text dark:text-contrast-yellow">
            {{ item.label | translate }}
        </span>
    </li>
</ng-template>
